import { Address } from 'framework/address'

interface FazendinhaAddress {
  id: number
  cliente_id: number
  cidade_id: number
  destinatario: string
  tipo_endereco: 'ENTREGA' | 'COBRANCA'
  numero: string
  logradouro: string
  complemento: string
  cep: string
  bairro: string
  cidade: string
  estado: string
  uf: string
  created_at: string
  updated_at: string
}

interface FazendinhaCustomerAddresses {
  billing_address: FazendinhaAddress
  shipping_address: FazendinhaAddress[]
}

export default function parser(address: FazendinhaCustomerAddresses): Address[] {
  const billing = address.billing_address
  const shipping = address.shipping_address

  const addresses = []

  shipping.map((ad: FazendinhaAddress) => {
    addresses.push({
      id: ad.id.toString(),
      recipient: ad.destinatario,
      street: ad.logradouro,
      neighborhood: ad.bairro,
      number: ad.numero,
      complement: ad.complemento,
      city: {
        id: ad?.cidade_id?.toString() || '1',
        name: ad?.cidade,
        district: ad?.uf,
      },
      zipCode: ad.cep,
      type: 'ENTREGA',
      active: true,
    } as Address)
  })

  if (billing) {
    addresses.push({
      id: billing.id.toString(),
      recipient: billing.destinatario,
      street: billing.logradouro,
      neighborhood: billing.bairro,
      number: billing.numero,
      complement: billing.complemento,
      city: {
        id: billing?.cidade_id?.toString() || '1',
        name: billing?.cidade,
        district: billing?.uf,
      },
      zipCode: billing.cep,
      type: 'COBRANCA',
      active: true,
    } as Address)
  }

  return addresses
}

export function parserAddress(shipping: FazendinhaAddress, type: 'COBRANCA' | 'ENTREGA' = 'COBRANCA'): Address {
  return {
    id: shipping.id.toString(),
    recipient: shipping.destinatario,
    street: shipping.logradouro,
    neighborhood: shipping.bairro,
    number: shipping.numero,
    complement: shipping.complemento,
    city: {
      id: shipping?.cidade_id?.toString() || '1',
      name: shipping?.cidade,
      district: shipping?.uf,
    },
    zipCode: shipping.cep,
    type,
    active: true,
  }
}
